import { defaultApplicantName } from '../../../../../../../constants';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import { FinancialStatementFourYearsAgoFullYearRuleset } from '../../business/ruleset';
import { taxDocuments } from '../../form_models/loanFormModel';

const { financialStatementFourYearsAgoFullYear } = taxDocuments;

export class FinancialStatementFourYearsAgoFullYearValidation
  implements ValidationSchema
{
  public name = financialStatementFourYearsAgoFullYear.name;
  public label =
    financialStatementFourYearsAgoFullYear.getLabel(defaultApplicantName);
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = FinancialStatementFourYearsAgoFullYearRuleset;

  public when(...args: any[]) {
    const result: RulesetResult = args.pop();
    const required = !!(result & RulesetResult.REQUIRED);
    return FileNameValidationSchema(
      financialStatementFourYearsAgoFullYear.name,
      required
    );
  }
}
export default new Validation(
  new FinancialStatementFourYearsAgoFullYearValidation()
);
